export enum AssociadoAuthLocalStorageNames {
  AccessToken = 'auth',
}